import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { FieldError } from "react-hook-form";

import FormInputLabel from "./FormInputLabel";

export type FormDateInputProps = {
    id: string,
    label?: string
    value: Date | null
    onChange: (value: Date | null) => void
    error?: FieldError
    minDate?: Date
    maxDate?: Date
    required?: boolean
    hideHelpText?: boolean
    helperText?: string
    tooltip?: string
}

const FormDateInput = ({
    id,
    label,
    value,
    onChange,
    error,
    minDate,
    maxDate,
    required,
    hideHelpText,
    helperText = "day/month/year",
    tooltip
}: FormDateInputProps) => {
    return (
        <div className="w-full space-y-2">
            {label && <FormInputLabel tooltipText={tooltip} htmlFor={id} required={required}>{label}</FormInputLabel>}
            <DesktopDatePicker
                format="dd/MM/yyyy"
                value={value}
                onOpen={() => {
                    if (!value && minDate) {
                        onChange(minDate);
                    }
                }}
                onChange={onChange}
                minDate={minDate}
                maxDate={maxDate}
                slotProps={{
                    textField: {
                        id,
                        required,
                        fullWidth: true,
                        variant: "outlined",
                        error: !!error,
                        helperText: hideHelpText ? undefined : (error?.message ?? helperText),
                        sx: {
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "12px",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "black",
                            },
                            "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "black",
                            },
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "black",
                                borderWidth: "1px",
                            },
                            "& .MuiOutlinedInput-input": {
                                padding: "16px",
                            },
                        },
                    },
                }}
            />
        </div>
    );
};

export default FormDateInput;